import { render, staticRenderFns } from "./MonthlyBookingCounts.vue?vue&type=template&id=684c12bf&"
import script from "./MonthlyBookingCounts.vue?vue&type=script&lang=js&"
export * from "./MonthlyBookingCounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports